import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Dropdown } from '../../../FlowConfigurationInputs';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function DoubleClick({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.RECORDER.CLICK.';
    const options = {
        dropdown: {
            data: [
                { value: 'right', label: 'Right' },
                { value: 'left', label: 'Left' }
            ],
            defaultValue: ''
        }
    }

    return (<>
        <div className="form-element">
            X : <TextInput action={action} inputName="x" variables={variables}
                setOpenVariable={setOpenVariable} filter="string" disabled />
        </div>
        <div className="form-element">
            Y : <TextInput action={action} inputName="y" variables={variables}
                setOpenVariable={setOpenVariable} filter="string" disabled />
        </div>
        <div className="form-element">
            {t(label + 'TYPE')} : &nbsp; <Dropdown action={action} inputName="value"
                options={options.dropdown} fullWidth={false} />
        </div>
        {action.fields.image?.byteValue && <img src={`data:image/jpeg;base64,${action.fields.image.byteValue}`} alt="autommate_doubleclick" />}
    </>
    );
}

export default DoubleClick;
